import { css } from 'styled-components';

export const BaseDebugContainer = css`
  background: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray300};
  border-radius: ${p => p.theme.borderRadius.large};
  box-sizing: border-box;
  box-shadow: ${p => p.theme.boxShadow.small};
  min-height: 100px;
  padding: 24px;
`;
